export const MIN_LEN = 0;
export const FORM_LEN = 1;
export const JSON_STR_BASE = 2;

export const POLLING_STATUS = {
  // Continue polling
  PENDING: 'PENDING',
  FABRIC_UPDATED: 'FABRIC_UPDATED',

  // Stop polling - Success
  READ_STORE_UPDATED: 'READ_STORE_UPDATED',

  // Stop polling - Failure
  ERROR_FABRIC: 'ERROR_FABRIC',
  ERROR_SERVICE: 'ERROR_SERVICE',
  ERROR_BUS: 'ERROR_BUS',
} as const;

export type PollingStatus = typeof POLLING_STATUS[keyof typeof POLLING_STATUS];
